import { ProductTypeEnum as t } from "../../enums/product-type-enum.mjs";
import { StoreItemEnum as o } from "../../../../enums/store-item-enum.mjs";
const l = {
  type: o.product,
  productType: t.download,
  title: "Check it out!",
  subTitle: `Check it out! \r
and get a DISCOUNT!`,
  buttonTitle: "Click Me!",
  thumbnail: null,
  checkoutPage: {}
};
export {
  l as defaultProductDownloadValues
};
